function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 469.847 469.847"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M270.336 234.965 34.39 462.165a40.15 40.15 0 0 1-17.493-33.493V41.258A40.15 40.15 0 0 1 34.39 7.765z",
    style: {
      fill: "#2196f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.896 155.605-82.56 79.36L34.39 7.765a32 32 0 0 1 2.773-1.92 40.36 40.36 0 0 1 40.747-.64z",
    style: {
      fill: "#4caf50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.95 234.965a40.79 40.79 0 0 1-21.333 36.267l-78.72 43.093-82.56-79.36 82.56-79.36 78.72 43.093a40.79 40.79 0 0 1 21.333 36.267",
    style: {
      fill: "#ffc107"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.896 314.325 77.91 464.725a40.9 40.9 0 0 1-40.747-.64 32 32 0 0 1-2.773-1.92l235.947-227.2z",
    style: {
      fill: "#f44336"
    }
  }));
};
export default SvgGooglePlay;